import { post, get, geted, wordpost } from '../network/index.js'

export default {
  //团购订单管理 - 订单列表
  getGroupOrderList: data => post('/mercWebi/order/getGroupOrderList', data),

  //团购订单管理 - 订单详情
  queryOrderDetail: data => post('/mercWebi/order/getOrderDetail', data),

  //团购订单管理 - 订单状态数量
  getSumOrdserStatus: data => post('/mercWebi/order/getSumOrdserStatus', data),

  //  查询劵码的预约使用记录
  queryCodeBookedInfo: data => post('/mercWebi/subscribeOrder/queryCodeBookedInfo', data),

  //团购订单退款
  refundGroupOrder: data => post('/mercWebi/order/refundGroupOrder', data),

  // 商家后台 - 查询订单支付信息
  queryOrderPayList: data => post('/mercWebi/order/queryOrderPayList', data),

  // 商家后台 --> 新增家政订单备注
  insertOrderRemarke: data => post('/mercWebi/order/insertOrderRemarke', data),

  // 商家后台 --> 修改家政订单备注
  modifyOrderRemarke: data => post('/mercWebi/order/modifyOrderRemarke', data),

  // 商家后台 --> 删除家政订单备注
  deleteOrderRemarke: data => post('/mercWebi/order/deleteOrderRemarke', data),

  // 商家后台 --> 导出团购订单列表
  downloadGroupOrderList: data => post('/mercWebi/order/downloadGroupOrderList', data),

  //商品订单列表
  queryTakeoutList: data => post('/mercWebi/order/getTakeOutOrderList', data),

  queryTakeOutSums: data => post('/mercWebi/order/getSumOrdserStatus', data),

  //估价订单列表
  evalOrderList: data => post('/eval-price-order/page', data),

  evalOrderStatusCount: data => get('/eval-price-order/status-count-list', data),

  //估价交易记录
  evalTradeRecord: data => post('/eval-price-order/trade-record', data),

  //估价 终估
  finalEval: data => post('/eval-price-order/final-eval', data),

  //估价 初估
  firstEval: data => post('/eval-price-order/first-eval', data),

  //估价订单详情
  evalOrderDetail: data => geted('/eval-price-order/detail', data),

  //洗护订单列表
  queryWashOrderList: data => post('/mercWebi/order/queryWashOrderList', data),

  //洗护订单美团失败列表
  queryWashMeiTuanOrderList: data => post('/mercWebi/order/queryWashOrderByStatusList', data),

  //洗护订单详情
  queryWashOrderDetail: data => post('/mercWebi/order/queryWashOrderDetail', data),

  //美团订单-重新推送
  updateorderfulfillinfo: data => post('/dzopen/book/updateorderfulfillinfo', data),

  //洗护订单-修改地址
  washOrderUpdateAddress: data => post('/mercWebi/order/updateAddress', data),

  // 洗护订单导出
  excelWashOrderList: data => wordpost('/mercWebi/order/excelWashOrderList', data),
  // excelWashOrderList: data => post('/mercWebi/order/excelWashOrderList', data),

  // 回收订单--列表
  recoveryList: data => post('/recovery-order/page', data),

  // 回收订单--回收订单详情
  recoveryDetail: data => geted('/recovery-order/detail', data),

  // 回收订单--确认打款金额
  recoveryPay: data => post('/recovery-order/pay', data),

  // 回收订单--拒绝回收
  recoveryRefuse: data => post('/recovery-order/refuse', data),

  // 回收订单--回收确认
  recoveryConfirm: data => post('/recovery-order/confirm', data),

  // 回收订单--退回寄件
  recoveryBack: data => post('/recovery-order/back', data),

  // 回收订单-状态数量
  recoveryStatus: data => get('/recovery-order/status-count-list', data),

  // 快递列表
  expressList: data => get('/recovery-order/express-list', data),

  // 团购-快递列表
  getLogistList: data => post('/mercWebi/order/getLogistList', data),

  // 团购-实物商品发货
  groupOrderSend: data => post('/mercWebi/order/groupOrderSend', data),

  // 团购-实物商品签收
  groupOrderSignFor: data => post('/mercWebi/order/groupOrderSignFor', data),

  // 抖音-团单可退商品
  getRefundableList: data => post('/dy/order/refundableList', data),

  // 抖音-团单商家退款
  dyCancelOrder: data => post('/mercWebi/dy/order/mercCreateRefund', data),

  // 抖音-团单商家取消预约订单
  cancelReservationOrder: data => post('/dy/order/mercCancelReservation', data),

  // 商城-订单列表
  queryMallOrderList: data => post('/mercWebi/order/mall/listByPage', data),
  // 商城-订单详情
  queryMallOrderDetail: data => post('/mercWebi/order/mall/getOrderDetail', data),
  // 商城-查询子订单商品列表
  getSubOrderGoodsList: data => post('/mercWebi/order/mall/getSubOrderGoodsList', data),
  // 商城-拣货
  mallOrderPick: data => post('/mercWebi/order/mall/pickGoods', data),
  // 商城-发货
  mallOrderDelivery: data => post('/mercWebi/order/mall/deliveryGoods', data),
  // 商城-快递签收
  mallExpressSign: data => post('/mercWebi/order/mall/expressSign', data),
  // 商城-改价
  mallChangePrice: data => post('/mercWebi/order/mall/changePrice', data),
  // 商城-修改子订单配送地址
  mallUpdateSubOrderAddress: data => post('/mercWebi/order/mall/updateSubOrderAddress', data),
  // 商城-全额退款
  mallFullAmountRefund: data => post('/mercWebi/order/mall/fullAmountNew', data),
  // 商城-订单状态数量统计（待支付、已支付、已拣货）
  mallOrderCountByStatus: data => post('/mercWebi/order/mall/countByStatus', data),
  // 商城-打单
  mallReceiptPrint: data => post('/mercWebi/order/mall/receiptPrint', data)
}
